"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Slider;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SliderModule = _interopRequireDefault(require("./Slider.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var THUMB_WIDTH_PX = 12;

function Slider(_ref) {
  var _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? 0 : _ref$initialValue,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
      onChange = _ref.onChange,
      isDisabled = _ref.isDisabled,
      _ref$inStepsOfTen = _ref.inStepsOfTen,
      inStepsOfTen = _ref$inStepsOfTen === void 0 ? false : _ref$inStepsOfTen,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$fillerClassName = _ref.fillerClassName,
      fillerClassName = _ref$fillerClassName === void 0 ? "" : _ref$fillerClassName,
      style = _ref.style;
  var sliderRef = (0, _react.useRef)(null);
  var thumbWrapperRef = (0, _react.useRef)(null);
  var thumbRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      thumbWrapperWidth = _useState2[0],
      setThumbWrapperWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      thumbWrapperOffsetLeft = _useState4[0],
      setThumbWrapperOffsetLeft = _useState4[1];

  var _useState5 = (0, _react.useState)(Math.min(Math.max(initialValue, minValue), maxValue)),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMouseDown = _useState8[0],
      setIsMouseDown = _useState8[1];

  var getThumbLeft = (0, _react.useCallback)(function () {
    var left = (thumbWrapperWidth - THUMB_WIDTH_PX) / 100 * value;
    return "".concat(left, "px");
  }, [value, thumbWrapperWidth]);
  var changeVal = (0, _react.useCallback)(function (event) {
    var clickLeftOffset = event.clientX - thumbWrapperOffsetLeft;
    var newValueUnbound = 100 * clickLeftOffset / (thumbWrapperWidth - 1);
    var newValue = Math.min(Math.max(newValueUnbound, minValue), maxValue);
    if (inStepsOfTen) newValue = Math.round(newValue / 10) * 10;
    setValue(newValue);
    if (onChange) onChange(newValue);
  }, [thumbWrapperOffsetLeft, thumbWrapperWidth, minValue, maxValue, inStepsOfTen, onChange]);
  var handleMouseMove = (0, _react.useCallback)(function (event) {
    changeVal(event);
  }, [changeVal]);
  var handleMouseUp = (0, _react.useCallback)(function () {
    setIsMouseDown(false);
    document.removeEventListener("mouseup", handleMouseUp);
    document.removeEventListener("mousemove", handleMouseMove);
  }, [setIsMouseDown, handleMouseMove]);
  var handleOnMouseDown = (0, _react.useCallback)(function (event) {
    if (isDisabled) return;
    setIsMouseDown(true);
    changeVal(event);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  }, [setIsMouseDown, changeVal, isDisabled, handleMouseMove, handleMouseUp]);
  (0, _react.useEffect)(function () {
    if (thumbWrapperRef.current) {
      setThumbWrapperWidth(thumbWrapperRef.current.offsetWidth);
      setThumbWrapperOffsetLeft(thumbWrapperRef.current.getBoundingClientRect().left);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: sliderRef,
    className: (0, _classnames.default)(_SliderModule.default.slider, isDisabled && _SliderModule.default.isDisabled, isMouseDown && _SliderModule.default.isMouseDown, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: thumbWrapperRef,
    className: _SliderModule.default.thumbWrapper,
    onMouseDown: handleOnMouseDown
  }, /*#__PURE__*/_react.default.createElement("div", {
    onMouseDown: handleOnMouseDown,
    className: (0, _classnames.default)(_SliderModule.default.filler, fillerClassName),
    style: {
      width: getThumbLeft()
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: thumbRef,
    onMouseDown: handleOnMouseDown,
    className: _SliderModule.default.thumb,
    style: {
      left: getThumbLeft()
    }
  })));
}